import Lottie, { Options } from "react-lottie";

import { defaultOptions } from "../defaultProps";
import { LottieProps } from "../types";
import animation from "./json.json";

export function LErrorIcon({ ...props }: LottieProps) {
  const newOptions = {
    ...defaultOptions,
    animationData: animation
  } as Options;

  return <Lottie {...props} options={newOptions} />;
}
